import { render, staticRenderFns } from "./productdetail.vue?vue&type=template&id=787b9e70&scoped=true"
import script from "./productdetail.vue?vue&type=script&lang=js"
export * from "./productdetail.vue?vue&type=script&lang=js"
import style0 from "./productdetail.vue?vue&type=style&index=0&id=787b9e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b9e70",
  null
  
)

export default component.exports